export default {
  NORTH: 0,
  EAST: 1,
  SOUTH: 2,
  WEST: 3
};
